// 钉钉相关接口
import http from '@/utils/network/general/http'

// 钉钉免登授权登录
export function login (data) {
  return http.post('/DingTalk/Login', data)
}

// 获取出差申请信息列表
export function getTripApplicationInfoes (params) {
  return http.get('/DingTalk/GetTripApplicationInfoes', params)
}
